const dayjs = require('dayjs');

const formatDateHourWithoutYear = {
    install(Vue) {
        Vue.filter('formatDateHourWithoutYear', (value) => {
            // Subtrai 3 horas da data original
            const adjustedDate = dayjs(value).subtract(3, 'hour');

            // Formata a data sem o ano e ajusta a hora
            const result = `${adjustedDate.format('DD/MM')} às ${adjustedDate.format('HH:mm')}`;
            return result;
        });
    },
};

export default formatDateHourWithoutYear;
